// extracted by mini-css-extract-plugin
export default {"container":"QOBTvg","floatingText":"Wgq4cX"};